import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Paper, FormGroup } from '@material-ui/core';
// import { TablePagination } from '@material-ui/core';
import MaterialTable from 'material-table';
import { H4,Dialog, Collapse, MenuItem } from '@blueprintjs/core';
import { MultiSelect } from '@blueprintjs/select';
// import { Tabs,Tab  } from '@blueprintjs/core';
// import EnhancedSingleSelect from '../../../common/EnhancedSingleSelect';
import Chart from 'react-apexcharts';
import VocSpecPopup from './VocSpecPopup.js';
import { rounded } from '../../../utils.js'
// import { PUBLIC_URL, ANALYTICS_URL } from '../../../constants';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Cookies from 'js-cookie';
import { FRONT_USER_LANG_COOKIE_NAME } from '../../../auth/constants.js';

import './VocAll.css';
// import { min } from 'lodash';


class VocAll extends React.PureComponent {

  state = {
    isOpenModal:false,
    selectedSubCorpus:[],
    currentKey:"",    // the key to send to VocSpecPopup
    currentTab:'lemma',
    filterByCat: '',
   // selectedTabId:null
  }

  vocSpecPopupLemma = (e) => {
    this.setState({currentKey:e.target.value, currentTab:'lemma'});
    this.toggleModal();
  }

  vocSpecPopupCat = (e) => {
    this.setState({currentKey:e.target.value, currentTab:'cat'});
    this.toggleModal();
  }

  toggleModal = () => {
    this.setState(prevState => ({ isOpenModal: !prevState.isOpenModal }));
  }

  calcQuery = (entry,fea) => {
    fea=(!fea) ? "l":fea;
    if (entry.match(/^([^_]*)_(.*)/)) {
      return encodeURIComponent("<"+fea+"="+RegExp.$1+",c="+RegExp.$2+",#1>");
    } else if (entry.match(/ /)) {
      return encodeURIComponent(entry.split(/ /).map( (t,i) => "<"+fea+"="+t+",#"+i.toString()+">").join(""));
    } else {
      return encodeURIComponent("<"+fea+"="+entry+",#1>");
    }
  }
  
  renderFeatureStatKey = ( featureStatsKey, categs ) => {
    
    delete(categs["other"]);
    const labels = Object.keys(categs).sort();
    const series = Object.keys(categs).sort().map( categ => 
      categs[categ]
    ) 
    return (
      <div key={featureStatsKey} style={{width:'500px'}}>
        <Chart 
          options={{
            chart: {
              type: 'pie',
              //width: 200
            },
            customScale: 1,
            labels: labels,
            title : {
              text:featureStatsKey,
              align:'center'
            }
            
          }}
          type={"pie"}
          series={series} 
          width={500} 
          title={{
            text:featureStatsKey
          }}
        />
      </div>
    );
  }
  handleSelectChange = (e) => {
    const { value } = e.target;
    this.setState({filterByCat:value});
  }

  tableComponent=(label,data,columnDefinition) => {
    return (
      <MaterialTable
        columns={columnDefinition}
        data={data}
        title=""
        options={{
          filtering: true,
          search: true,
          sorting: true,
          exportButton: true,
          exportFile: label,
          exportAlldata: true,
          rowStyle: {
            height:'40px',
            maxHeight:'40px',
          },
          cellStyle: {
            textAlign:'right'
          },
          //pageSize:10,
          padding: 'dense',
        // tableLayout: 'fixed',
        }}
      />);
  }

  selectSubCorpus=(subCorpus)=>{
    if (! this.state.selectedSubCorpus.includes(subCorpus)) {
      //console.log("ajout de "+subCorpus,selectedSubCorpus )
      this.setState({selectedSubCorpus:[...this.state.selectedSubCorpus, subCorpus]});
    }
  }
  removeSubCorpus=(subCorpus)=>{
    const selectedSubCorpus=this.state.selectedSubCorpus;
    const index = selectedSubCorpus.indexOf(subCorpus);
    if (index > -1) { 
      selectedSubCorpus.splice(index, 1);
      // attention : modifier la référence de la liste sinon pas de rerendering
      this.setState({selectedSubCorpus:[...selectedSubCorpus]}); 
      //console.log("suppression de "+subCorpus,this.state.selectedSubCorpus )
    }
   
  }

  render() {
    const {
        subCorpora, 
        size, 
        vocSize,
        nbDocs,
        nbSents,
        nbParas,
        nbCls,
        nbForms,
        averageLength,
        featureStats,
        repet4cat,
        dist4cat,
        lexicalDensity,
        // lemmaStats, 
        // catStats,
        // cats,
        // name,
        displayLexicoStats,
        maxSpanSize,
        TTRSpanSize,
        STTR,
        useLemma4Repet, 
        t 
      } = this.props;
    const { isOpenModal} = this.state;
    const langFormat = Cookies.get(FRONT_USER_LANG_COOKIE_NAME)==="en"? "en-EN":"fr-FR";
    

    // boolean to manage incomplete data
    const displayRepet4cat= displayLexicoStats  && (typeof repet4cat !=="undefined") && (repet4cat !== null);
    const displayFeatureStats= displayLexicoStats  && (typeof featureStats !=="undefined") && (featureStats !== null);

    // const urlParams = new URLSearchParams(window.location.search);
    // const session_id = urlParams.get('session_id');

    // tables of divs for each subCorpus
    const featureStatsDivs=[]; 
    const repet4catDivs=[];
    // const lemmaTableDivs=[];
    // const catTableDivs=[];

    // let filterByCat=false;  // if true, display a select field to filter the table
     //  for subcorpus stats 
    // if (lemmaStats[0] && lemmaStats[0].length>0 && lemmaStats[0][0].match(/_/)) {
    //   filterByCat=true;
    // }

    const globalStatTableRows=[];
    const globalStatTablecolumnDefinition=[
      { title: t('subCorpus'), field: 'subCorpus' },
      { title: t('docNumber'), field: 'docNumber' },
      { title: t('paraNumber'), field: 'paraNumber' },
      { title: t('sentNumber'), field: 'sentNumber' },
      { title: t('clsNumber'), field: 'clsNumber' },
      { title: t('tokenNumber'), field: 'tokenNumber' },
      { title: t('formNumber'), field: 'formNumber' },
    ];
      
    const vocStatTableRows=[];
    const vocStatTablecolumnDefinition=[
      { title: t('subCorpus'), field: 'subCorpus' },
      { title: t('vocSize'), field: 'vocSize' },
      { title: t('TTR'), field: 'TTR' },
      { title: "STTR ("+t('for')+" "+(TTRSpanSize?TTRSpanSize.toString():"")+")", field: 'STTR' },
      { title: t('lexicalDensity'), field: 'lexicalDensity' },
    ];
  
    const readabilityTableRows=[];
    const readabilityTablecolumnDefinition=[
      { title: t('subCorpus'), field: 'subCorpus' },
      { title: t('averageSentLength'), field: 'averageSentLengthForms' },
      { title: t('averageLength'), field: 'averageWordLength' },
    ];

    // main loop, for each subCorpora (but __global__)
    for (const subCorpus of subCorpora) {
      // let lemmaCols;
      // let catCols;    
      // let dataLemmaTable = [];
      // let dataCatTable = [];

      globalStatTableRows.push({
        subCorpus:subCorpus,
        docNumber:Intl.NumberFormat(langFormat).format(nbDocs[subCorpus]),
        paraNumber:Intl.NumberFormat(langFormat).format(nbParas[subCorpus]),
        sentNumber:Intl.NumberFormat(langFormat).format(nbSents[subCorpus]),
        clsNumber:Intl.NumberFormat(langFormat).format(nbCls[subCorpus]),
        tokenNumber:Intl.NumberFormat(langFormat).format(size[subCorpus]),
        formNumber:Intl.NumberFormat(langFormat).format(nbForms[subCorpus])        
      });

      vocStatTableRows.push({
        subCorpus:subCorpus,
        vocSize: Intl.NumberFormat(langFormat).format(vocSize[subCorpus]),
        TTR: Intl.NumberFormat(langFormat).format(vocSize[subCorpus]/size[subCorpus]),
        STTR: Intl.NumberFormat(langFormat).format(STTR[subCorpus]),
        lexicalDensity: Intl.NumberFormat(langFormat).format(lexicalDensity[subCorpus]),
      });

      readabilityTableRows.push({
        subCorpus:subCorpus,
        averageSentLengthForms: Intl.NumberFormat(langFormat).format(rounded(nbForms[subCorpus]/nbSents[subCorpus])),
        averageWordLength: Intl.NumberFormat(langFormat).format(averageLength[subCorpus]),
      });
    
      //*** add featureStats DIV
      if (featureStats[subCorpus]) {
        featureStatsDivs.push(
          <div key={'featureStats_'+subCorpus} className="featureStats">
            <h3 className='corpusName'>{subCorpus}</h3>
          { Object.keys(featureStats[subCorpus]).sort().map( featureStatsKey => this.renderFeatureStatKey(featureStatsKey,featureStats[subCorpus][featureStatsKey]))}
          </div>
        );
      }
    

      //*** add lemmaTable and catTable DIV
      // if (lemmaStats[subCorpus][0] && lemmaStats[subCorpus][0].length===4) {
      //   for (var i=0;i<lemmaStats[subCorpus].length;i++) {
      //     const row = {
      //       num:i+1,
      //       lemma: lemmaStats[subCorpus][i][0],
      //       freq: lemmaStats[subCorpus][i][1],
      //       totFreq: lemmaStats[subCorpus][i][2],
      //       spec: lemmaStats[subCorpus][i][3],
      //     };
      //     dataLemmaTable.push(row);
      //   }

      //   lemmaCols=[
      //     { title: t('rank'), field:'num' },
      //     { title: t('lemma'), 
      //       render: row => <a target='blank' href={PUBLIC_URL+ANALYTICS_URL+'?query='+this.calcQuery(row.lemma)+'&session_id='+ session_id} >{row.lemma}</a>,
      //       customFilterAndSearch: (term, rowData) => rowData.lemma.match(term),
      //       defaultFilter:this.state.filterByCat
      //     },
      //     { title: t('frequency'), field:'freq' },
      //     { title: t('totFreq'), field:'totFreq' },
      //     { title: t('specificity') , field:'spec'},
      //     { title: t('compare'), render: row => <button value={row.lemma} onClick={this.vocSpecPopupLemma}>cmp</button> },
      //   ];

      //   // catStats may be null (no spec cat)
      //   if (catStats[subCorpus]) {
      //     for (i=0;i<catStats[subCorpus].length;i++) {
      //       const row = {
      //         num:i+1,
      //         cat: catStats[subCorpus][i][0],
      //         freq: catStats[subCorpus][i][1],
      //         totFreq: catStats[subCorpus][i][2],
      //         spec: catStats[subCorpus][i][3],
      //       };
      //       dataCatTable.push(row);
      //     }
      //   }

      //   catCols=[
      //     { title: t('rank'), field:'num' },
      //     { title: t('category'), field:'cat'  },
      //     { title: t('frequency'), field:'freq' },
      //     { title: t('totFreq'), field:'totFreq' },
      //     { title: t('specificity') , field:'spec'},
      //     { title: t('compare'), render: row => <button value={row.cat} onClick={this.vocSpecPopupCat}>cmp</button> },
      //   ];
      // } else {
      //   if (lemmaStats[subCorpus].length) {

      //     for (i=0;i<lemmaStats[subCorpus].length;i++) {
      //       const row = {
      //         num:i+1,
      //         lemma: lemmaStats[subCorpus][i][0],
      //         freq: lemmaStats[subCorpus][i][1],
      //         disp: lemmaStats[subCorpus][i][2],
      //       };
      //       dataLemmaTable.push(row);
      //     }

      //     // for global stats only
      //     lemmaCols=[
      //       { title: t('rank'), field:'num' },
      //       { title: t('lemma'), 
      //         render: row => <a target='blank' href={PUBLIC_URL+ANALYTICS_URL+'?query='+this.calcQuery(row.lemma)+'&session_id='+ session_id} >{row.lemma}</a>,
      //         customFilterAndSearch: (term, rowData) => rowData.lemma.match(term),
      //         defaultFilter:this.state.filterByCat
      //       },
      //       { title: t('frequency'), field:'freq' },
      //       { title: t('dispersion'), field:'disp' },
      //       { title: t('compare'), render: row => <button value={row.lemma} onClick={this.vocSpecPopupLemma}>cmp</button> },
      //     ];
      //   }

      //   // catStats may be null (no spec cat)
      //   if (catStats[subCorpus]) {
      //     for (i=0;i<catStats[subCorpus].length;i++) {
      //       const row = {
      //         num:i+1,
      //         cat: catStats[subCorpus][i][0],
      //         freq: catStats[subCorpus][i][1],
      //         disp: catStats[subCorpus][i][2],
      //       };
      //       dataCatTable.push(row);
      //     }

      //     catCols=[
      //       { title: t('rank'), field:'num' },
      //       { title: t('category'), field:'cat' },
      //       { title: t('frequency'), field:'freq' },
      //       { title: t('dispersion'), field:'disp' },
      //       { title: t('compare'), render: row => <button value={row.cat} onClick={this.vocSpecPopupCat}>cmp</button> },
      //     ];
      //   }
      // }

      // lemmaTableDivs.push(
      //   <div key={'lemmeTable_'+subCorpus} >
      //     <h3 className='corpusName'>{subCorpus}</h3>
      //     { filterByCat && 
      //       <EnhancedSingleSelect
      //         label={t('filterByCat')}
      //         options={cats}
      //         name='filter'
      //         hasDefault={true}
      //         hasSelectableDefault={true}
      //         onChange={this.handleSelectChange}
      //         popoverProps={{ minimal: true }}
      //       />
      //     }
      //     <div style={{marginLeft:"10px"}}>
      //       <MaterialTable
      //         title={t('lemma')}        
      //         columns={lemmaCols}
      //         data={dataLemmaTable}
      //         options={{
      //           filtering: true,
      //           search: true,
      //           sorting: true,
      //           exportButton: true,
      //           exportFileName:`${name}_lemma`,
      //           exportAllData: true,
      //           padding: 'dense',
      //           pageSize:min([100,dataLemmaTable.length]),
      //         }}
      //         components={{
      //           Pagination: props => (
      //             <TablePagination
      //               {...props}
      //               rowsPerPageOptions={[10, 100, 1000, dataLemmaTable.length]}
      //             />
      //           ),
      //           Container: props => (
      //             <Paper
      //               {...props}
      //               elevation={0}
      //               className='straight'
      //             />
      //           ),
      //         }}
      //       />
      //     </div>
      //   </div>  
      // );

      // catTableDivs.push (
      //   <div key={'catTable_'+subCorpus}>
      //     <h3 className='corpusName'>{subCorpus}</h3>
      //     <div style={{marginLeft:"10px"}}>
      //       <MaterialTable
      //         title={t('category')}
      //         columns={catCols}
      //         data={dataCatTable}
      //         options={{
      //           filtering: true,
      //           search: true,
      //           sorting: true,
      //           exportButton: true,
      //           exportFileName:`${name}_pos`,
      //           exportAllData: true,
      //           pageSize:min([100,dataLemmaTable.length]),
      //           padding:'dense'
      //         }}
      //         components={{
      //           Pagination: props => (
      //             <TablePagination
      //               {...props}
      //               rowsPerPageOptions={[10, 100, 1000, dataCatTable.length]}
      //             />
      //           ),
      //           Container: props => (
      //             <Paper
      //               {...props}
      //               elevation={0}
      //             />
      //           ),
      //         }}
      //       />
      //     </div>
      //   </div>
      // );

      //*** add repet4Cat DIV
      if (displayRepet4cat && repet4cat[subCorpus]) {
        const repet4catBars=
          <Chart
            options={{

              plotOptions: {
                bar: {
                  columnWidth: '80%',
                }
              },
              dataLabels: {
                enabled: true,
              },
              xaxis: {
                type: 'text',
                categories: Object.keys(repet4cat[subCorpus]).sort(),
                labels: {
                  rotate: -90
                }
              }
            }}
            type="bar"
            width={300}
            series={[{ 
              name:t('repet4cat'),
              data: Object.keys(repet4cat['__global__']).sort().map( cat=>repet4cat[subCorpus][cat] )
            }]}
          />;
        
        const dist4catBars=dist4cat['__global__']? Object.keys(dist4cat['__global__']).sort().map( cat=> 
          <div key={cat}>
            <Chart
              options={{

                plotOptions: {
                  bar: {
                    columnWidth: '80%',
                    dataLabels: {
                      position:'top',
                    }
                  }
                },
                dataLabels: {
                  enabled: false,
                },
                title: {
                  text: cat,
                },
                xaxis: {
                  type: 'text',
                  categories: Object.keys(dist4cat[subCorpus][cat]?dist4cat[subCorpus][cat]:{}).sort((a,b) => parseInt(a)-parseInt(b)).map( range => range * maxSpanSize / 20 ),
                  labels: {
                    rotate: -90
                  }
                }
              }}
              type="bar"
              width={300}
              series={[{ 
                name:t('dist4cat'),
                data: Object.keys(dist4cat[subCorpus][cat]?dist4cat[subCorpus][cat]:{}).sort((a,b) => parseInt(a)-parseInt(b)).map( range =>dist4cat[subCorpus][cat][range] )
              }]}
            />
          </div>
        ):"";

        repet4catDivs.push(
          <Collapse key={'repet4cat_collapse_'+subCorpus} isOpen={this.state.selectedSubCorpus.includes(subCorpus)}>
            <div key={'repet4cat_'+subCorpus} >
              <h3 className='corpusName'>{subCorpus}</h3><br/>
              <div style={{width:'500px'}}>{ repet4catBars }{ dist4catBars }</div>
            
              <div >
                <p>{t("repet4catExplanation")}</p>
                <br/>
                <p>{t("maxSpanSizeColon")} { maxSpanSize }</p>
                <p>{t("useLemma4RepetColon")} { useLemma4Repet===1? t("lemma") : t("form") }</p>
              </div>
          
            </div>
          </Collapse>
        );
      }
    }
    // const lemmaTable= <div className="columnDiv">{lemmaTableDivs}</div>;
    // const catTable= <div className="columnDiv">{catTableDivs}</div>;

    return(
      <>
        <Paper className="margin-bottom-1-rem padding-1-rem">
          <Accordion defaultExpanded={true}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header1"
            >
              <H4>{t('globalStats')}</H4>
            </AccordionSummary>
            <AccordionDetails>
              {this.tableComponent(t('globalStats'),globalStatTableRows,globalStatTablecolumnDefinition)}
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header2"
            >
              <H4>{t('vocStats')}</H4>
            </AccordionSummary>
            <AccordionDetails>
                {this.tableComponent(t('vocStats'),vocStatTableRows,vocStatTablecolumnDefinition)}
            </AccordionDetails>
          </Accordion> 

          <Accordion>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header3"
            >
              <H4>{t('readability')}</H4>
            </AccordionSummary>
            <AccordionDetails>
              {this.tableComponent(t('readability'),readabilityTableRows,readabilityTablecolumnDefinition)}
            </AccordionDetails>
          </Accordion> 

          { (displayFeatureStats) &&
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
              <H4>{t('featureStats')}</H4>
              </AccordionSummary>
              <AccordionDetails style={{overflow:"scroll"}}>
                {featureStatsDivs}
              </AccordionDetails>
            </Accordion>   
          }
          { (displayRepet4cat) &&
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
              <H4>{t('repet4cat')}</H4>
              
              </AccordionSummary>
              <AccordionDetails style={{overflow:"scroll"}}>
                <div style={{marginRight:"30px"}}>
                  {t("selectTheCorpusToDisplay")}<br/><br/>
                  <FormGroup label={t('subCorpus')} >
                    <MultiSelect
                      items={subCorpora}
                      itemPredicate={(query, testedElement) => testedElement.includes(query)}
                      onItemSelect={(selectedItem) => this.selectSubCorpus(selectedItem) }
                      onRemove={(selectedItem) => this.removeSubCorpus(selectedItem) }
                      selectedItems={this.state.selectedSubCorpus}
                      tagInputProps={{
                        interactive: true,
                        onRemove: item => this.removeSubCorpus(item),
                      }}
                      itemRenderer={
                        (item, { handleClick, modifiers }) => (
                          <MenuItem
                            key={"menuItems"+item}
                            active={modifiers.active}
                            text={item}
                            icon={this.state.selectedSubCorpus.includes(item) ? 'tick' : 'blank'}
                            onClick={handleClick}
                            shouldDismissPopover={false}
                          />
                        )
                      }
                      tagRenderer={item => item}
                      placeholder={t('subCorpus')}
                    />
                  </FormGroup>
                </div>
              
                  
                {repet4catDivs}
                  
              </AccordionDetails>
            </Accordion> 
          }
        </Paper>
        {/* <Tabs onChange={this.handleTabChange} selectedTabId={this.state.selectedTabId}>
          <Tab key='lemma' id='lemma' title={name==='global'? t('globalLemmata'):t('specificLemmata')} panel={lemmaTable} />
          <Tab key='cat' id='cat' title={name==='global'? t('globalPos'):t('specificPos')} panel={catTable} />
        </Tabs> */}

        <Dialog
            isOpen={isOpenModal}
            onClose={this.toggleModal}
            title={t('vocSpecComparison')}
            style={{'width': '800px'}}  // 800px seems a good deal
        >
          <VocSpecPopup entry={this.state.currentKey} data={this.props.spec[this.state.currentTab][this.state.currentKey]}/>
        </Dialog>
        
      </>
    );
  }

}

VocAll.propTypes = {
  subCorpora: PropTypes.array,
  lemmaStats: PropTypes.object,
  catStats: PropTypes.object,
  cats: PropTypes.array,
  size: PropTypes.object,
  vocSize: PropTypes.object,
  spec: PropTypes.object,
  featureStats: PropTypes.object,
  nbDocs: PropTypes.object,
  nbSents: PropTypes.object,
  nbParas: PropTypes.object,
  nbCls: PropTypes.object,
  nbForms: PropTypes.object,
  lexicalDensity: PropTypes.object,
  averageLength: PropTypes.object,
  repet4cat: PropTypes.object,
  dist4cats: PropTypes.object,
  maxSpanSize: PropTypes.number,
  STTR:PropTypes.array,
  TTRSpanSize: PropTypes.number,
  useLemma4Repet : PropTypes.number,
  displayLexicoStats:  PropTypes.bool,
  diffStats: PropTypes.object
};

export default withTranslation()(VocAll);
